import clsx from 'clsx';
import React from 'react';
import './FillBar.scss';
const FillBar = ({ isLoading }) => (React.createElement("div", { className: clsx('fill-bar', { 'finish-loading': !isLoading }) }));
export default FillBar;
